import Rest from '@/services/Rest'

export default class JasperService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/jaspers';

  /**
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  enabled() {
    return this.get(`/enabled`)
  }

  /**
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  available() {
    return this.get(`/available`)
  }

  /**
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  jrxml(id) {
    return this.get(`/jrxml?id=${id}`)
  }

  /**
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  models(uri) {
    return this.get(`/models?uri=${uri}`)
  }

  updateJrxml(uri, data){
    return this.put(`/jrxml`, {
      uri: uri,
      data: data
    })
  }

  createJrxml(uri, data){
    return this.post(`/jrxml`, {
      uri: uri,
      data: data
    })
  }


}
